import { createAction, props } from '@ngrx/store';
import { VolunteerOfMonthDto } from '@klubovna/api-client';

export const loadVolunteerOfMonth = createAction('[Volunteers] Load Volunteer Of Month');
export const loadVolunteerOfMonthSuccess = createAction(
  '[Volunteers] Load Volunteer Of Month Success',
  props<{ volunteerOfMonth: VolunteerOfMonthDto }>(),
);
export const loadVolunteerOfMonthFailure = createAction(
  '[Volunteers] Load Volunteer Of Month Failure',
  props<{ error: string }>(),
);
